import { advantages } from "../data/mock";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

export const AdvantagesSection = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section ref={ref} id="avantages" className="py-[100px] md:py-[120px] bg-[#f0efe8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div
          className={`mb-16 max-w-[600px] transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p
            className="text-[12px] tracking-[0.2em] uppercase text-[#c9a84c] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Pourquoi nous choisir
          </p>
          <h2
            className="text-[30px] md:text-[36px] font-normal text-[#1a1d2e] leading-[1.2] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Les avantages de votre VTC
          </h2>
          <div className="gold-line mb-6" />
          <p
            className="text-[16px] text-[#555] leading-[1.7]"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Un service de transport premium avec des garanties concrètes pour votre confort et votre tranquillité.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, idx) => (
            <div
              key={idx}
              className={`bg-[#f8f7f2] p-8 md:p-10 border border-transparent hover:border-[#c9a84c]/30 transition-all duration-700 hover:translate-y-[-2px] hover:shadow-[0_4px_20px_rgba(0,0,0,0.06)] group ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${200 + idx * 100}ms` }}
            >
              <div className="w-[48px] h-[48px] flex items-center justify-center border border-[#c9a84c]/30 mb-6 transition-all duration-200 group-hover:border-[#c9a84c] group-hover:bg-[#c9a84c]/5">
                <advantage.icon
                  size={22}
                  strokeWidth={1.5}
                  className="text-[#c9a84c]"
                />
              </div>

              <h3
                className="text-[18px] font-normal text-[#1a1d2e] mb-3 leading-[1.3]"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {advantage.title}
              </h3>

              <p
                className="text-[14px] text-[#555] leading-[1.6]"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
